import React from "react";
import { DecryptedType } from "@/scenes/OrderManagement/hooks/useListDecryptedConsignee";
import { useGlobalStore } from "@/store/hooks";
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, message } from "antd";
import { observer } from "mobx-react-lite";
import { observable } from "mobx";
import { MenuDivider, MenuItem, MenuItemGroup, SubMenu, buildMenuItems } from "@/utils/antdItems";

const CACHE_KEY = "GLOBAL_TAOBAO_DEFAULT_DECRYPT_TYPE";

const cacheType = observable.box<DecryptedType>(
    (localStorage.getItem(CACHE_KEY) as DecryptedType) || DecryptedType.NAME_AND_STREET,
);

interface ConsigneeDecryptTBButtonProps {
    shopId?: number;

    onDecryptedConsigneeClick?(type: DecryptedType): void;
}

interface DefaultButtonProps {
    type: DecryptedType;
}

const DefaultButton: React.FC<DefaultButtonProps> = observer(function (props) {
    const { type } = props;

    if (cacheType.get() === type) {
        return (
            <Button
                type="link"
                className="tb-default-decrypt-type-button"
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    message.success("已设为默认");
                }}
            >
                已设为默认
            </Button>
        );
    }

    return (
        <Button
            type="link"
            className="tb-set-default-decrypt-type-button"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                localStorage.setItem(CACHE_KEY, type);
                cacheType.set(type);

                message.success("设置成功");
            }}
        >
            设为默认
        </Button>
    );
});

const ConsigneeDecryptTBButton: React.FC<ConsigneeDecryptTBButtonProps> = function (props) {
    const { shopId, onDecryptedConsigneeClick } = props;

    const globalStore = useGlobalStore();

    const currentUser = globalStore.currentUser;

    return (
        <Dropdown menu={{ items: [] }}
            rootClassName="tb-default-decrypt-dropdown-container"
            popupRender={() => {
                return (
                    <Menu
                        onClick={(e) => {
                            const type = e.key as DecryptedType;

                            onDecryptedConsigneeClick(type);
                        }}
                     items={buildMenuItems(<>
                        {!import.meta.env.VITE_IS_QN || currentUser?.shopId === shopId ? (
                            <MenuItem key={DecryptedType.NAME_AND_STREET}>
                                <span>
                                    仅查看姓名和地址<span className="text-gray">(免费)</span>
                                </span>

                                <DefaultButton type={DecryptedType.NAME_AND_STREET} />
                            </MenuItem>
                        ) : null}

                        <MenuItem key={DecryptedType.ALL}>
                            查看完整收货人信息：虚拟号
                            <span className="text-gray">(收费)</span>
                            <DefaultButton type={DecryptedType.ALL} />
                        </MenuItem>

                        <MenuItem key={DecryptedType.PLATFORM}>
                            去后台查看完整收货人信息 <span className="text-gray">(免费)</span>
                            <DefaultButton type={DecryptedType.PLATFORM} />
                        </MenuItem>
                    </>)} />
                );
            }}
        >
            <a
                role="button"
                tabIndex={-1}
                className="ml5 small text-light link-btn"
                onClick={(e) => {
                    e.preventDefault();

                    const type = cacheType.get();

                    if (!import.meta.env.VITE_IS_QN || currentUser?.shopId === shopId) {
                        onDecryptedConsigneeClick(type);
                    } else {
                        // 说明是千牛环境并且不是所属店铺,则看是否可解密
                        // 不能则降级回跳转淘宝
                        if ([DecryptedType.ALL, DecryptedType.PLATFORM].includes(type)) {
                            onDecryptedConsigneeClick(type);
                        } else {
                            onDecryptedConsigneeClick(DecryptedType.PLATFORM);
                        }
                    }
                }}
                style={{ userSelect: "none" }}
            >
                <span style={{ marginRight: 2 }}>查看</span>

                <DownOutlined />
            </a>
        </Dropdown>
    );
};

export default observer(ConsigneeDecryptTBButton);
